import { Directive } from '@angular/core';

@Directive({
  selector: '[modalFooter]'
})
export class ModalFooterDirective {}
